import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HelpersService } from "src/app/core/services/helpers.service";
import { OperationsService } from "src/app/core/services/operations.service";
import { PropertiesSettings as ps } from '../../../core/configuration/properties-settings';
import {
  ContributoUnificatoAdapter
} from "../../components/fascicolo/sezione-economica-contributo-unificato-add/contributo-unificato-adapter";
import { ContributoUnificato } from "../../models/contributo-unificato";
import {
  scaglioniContributoUnificatoOptions,
  tipiControbutoUnificatoOptions
} from "../../models/mock/sezione-economica/mock-contributo-unificato";
import { TipoGenericoRimovibile } from "../../models/tipologiche/tipo-generico-rimovibile";
import { TipoPetitum } from "../../models/tipologiche/tipo-petitum";
import { BaseForm } from "../base-Form";


@Component({
    selector: 'div [contributo-unificato-form]',
  templateUrl: 'contributo-unificato-form.component.html'
})

export abstract class ContributoUnificatoFormComponent extends BaseForm {
  idPetitumDefault = ps.ID_TIPO_PETITUM_NON_PRESENTE;
  request: ContributoUnificato;
  contributoUnificatoForm: FormGroup;
  tipiPetitumOptions: TipoPetitum[] = [];
  idPetitumQuantificabile = ps.ID_TIPO_PETITUM_QUANTIFICABILE;
  idTipoRevisioneWizard = ps.ID_TIPO_REVISIONE_WIZARD;
  recuperoCrediti: boolean;
  valoreImportoFisso: string | number;

  tipiContributoUnificato: TipoGenericoRimovibile[] = tipiControbutoUnificatoOptions;
  scaglioneContributoUnificatoOptions: any[] = scaglioniContributoUnificatoOptions;
  tipoContributoUnificatoSelected: TipoGenericoRimovibile;
  scaglioneContributoUnificatoSelected: any;

  abstract getEdit(): boolean;
  abstract getContributoUnificato(): ContributoUnificato;
  abstract getRequest(request: ContributoUnificato);

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

 initRequest() {
   this.request = new ContributoUnificatoAdapter(this.getContributoUnificato()).contributoUnificato;
   if(!this.inserimento){
     this.valoreImportoFisso = this.request.valoreImportoFisso;
     this.scaglioneContributoUnificatoSelected=this.request.valoreScaglione? this.scaglioneContributoUnificatoOptions.find(element=>element.valore===this.request.valoreScaglione) : null;
   }
  }

  createForm() {
      this.initRequest();
      this.contributoUnificatoForm = this.campiForm.group({
        importo: [this.request.valoreImportoFisso],
        tipoContributoUnificato: [this.request.tipoContributo, Validators.required],
        scaglioneContributoUnificato: [this.scaglioneContributoUnificatoSelected]
      });
  }

  populateSelect() {

  }

  setTipoContributoUnificato(tipoContributoUnificato: TipoGenericoRimovibile) {
    this.tipoContributoUnificatoSelected = tipoContributoUnificato;
    this.request.tipoContributo = tipoContributoUnificato.id;
    switch(tipoContributoUnificato.id){
      case 'ESENZIONE':
        this.contributoUnificatoForm.controls['importo'].clearValidators();
        this.request.valoreImportoFisso = null;
        this.request.valoreScaglione = null;
        this.scaglioneContributoUnificatoSelected = null;
        break;
      case 'IMPORTO':
        this.contributoUnificatoForm.controls['importo'].setValidators(Validators.required);
        // this.request.valoreScaglione = null;
        // this.scaglioneContributoUnificatoSelected = null;
        break;
      case 'SCAGLIONE':
        this.request.valoreImportoFisso = null;
        this.contributoUnificatoForm.controls['importo'].clearValidators();
        break;
      default: break;
    }
    this.contributoUnificatoForm.controls['importo'].updateValueAndValidity();
  }

  isTipoContributoUnificatoSelected(idTipoContributoUnificato: string) : boolean {
    return !!(this.request.tipoContributo && (this.request.tipoContributo === idTipoContributoUnificato));
  }

  onChangeScaglione(event){
    this.scaglioneContributoUnificatoSelected = event;
    this.request.valoreScaglione = event ? event.valore : null;
  }

  importoFissoValidation():boolean{
    return this.isTipoContributoUnificatoSelected('IMPORTO') ? !!(this.valoreImportoFisso) : true;
  }

  onChangeImportoFisso(event){
    this.valoreImportoFisso = Number.parseFloat(event.split('.').join('').replace(',', '.'));
  }

  save() {
    let requestCopy: ContributoUnificato = (new ContributoUnificatoAdapter(this.request)).contributoUnificato;
    //requestCopy.contributoCalcolato = null;
    this.getRequest(requestCopy);
  }
}
